import { Badge, Card, Col, Row } from "react-bootstrap";
import { COLOR_PRIMARY } from "../../../../constants/Colors";
import styled from "styled-components";
import {
  ADMIN,
  DADOR_DE_CARGA,
  TOMADOR_DE_CARGA,
} from "../../../../constants/UserType";
import { useState } from "react";

const BadgeLog = styled(Badge)`
  background-color: ${COLOR_PRIMARY};
  color: white;
  border-radius: 5px !important;
  text-align: center;
  display: inline-block;
  padding: 0px 20px;
`;

const stateLabels = {
  5: "Finalizado",
  4: "Ejecución",
  3: "Listo viajar",
};

const getUrlByRole = (role, tripId, detailId) => {
  switch (role) {
    case TOMADOR_DE_CARGA:
      return `my-travels-tc?state=3&tripId=${tripId}&detailTrip=${detailId}`;
    case ADMIN:
      return `travels-all?state=2&tripId=${tripId}&detailTrip=${detailId}`;
    case DADOR_DE_CARGA:
      return `list-travels?state=2&tripId=${tripId}&detailTrip=${detailId}`;
    default:
      return "/";
  }
};
function MapOverlay({
  domain,
  speed,
  onClose,
  dateTime,
  presicion,
  showId,
  state,
  detailId,
  tripId,
  origin,
  hideRoute,
  showRoute,
  destiny,
  role,
  isParentAccount = false,
  dador_info,
  details,
}) {
  const [visibleRoute, setVisibleRoute] = useState(false);
  const handleRouteToggle = () => {
    if (visibleRoute) {
      hideRoute();
    } else {
      showRoute();
    }
    setVisibleRoute(!visibleRoute);
  };

  return (
    <Card
      className="shadow-8dp aligned-raleway"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        position: "absolute",
        borderRadius: "10px",
        transform: "translateX(-50%)",
        bottom: 0,
        width: "240px",
        zIndex: 999,
      }}
    >
      <Card.Body className="p-3">
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            cursor: "pointer",
            fontWeight: 600,
            color: COLOR_PRIMARY,
            padding: "5px 10px 5px 5px",
          }}
          onClick={onClose}
        >
          X
        </div>
        <Row className="mb-2 mt-1">
          <Col className="pr-0">
            <h6 className="mb-0 text-primary font-weight-bold">
              {"ID: " + showId}
            </h6>
          </Col>
          <Col className="pl-0 text-center">
            <BadgeLog as="h6">{stateLabels[state] || "No disponible"}</BadgeLog>
          </Col>
        </Row>
        <Row className="mb-1">
          <Col xs={4} className="pr-0">
            <strong>Dominio:</strong>
          </Col>
          <Col xs={8}>{domain}</Col>
        </Row>
        {isParentAccount ? (
          <Row className="mb-1">
            <Col xs={4} className="pr-0">
              <strong>Cuenta:</strong>
            </Col>
            <Col xs={8}>
              {dador_info?.name
                ? `${dador_info.name} ${dador_info.last_name || ""}`
                : dador_info?.email || "Sin dato"}
            </Col>
          </Row>
        ) : null}
        <Row className="mb-1">
          <Col xs={4} className="pr-0">
            <strong>Origen:</strong>
          </Col>
          <Col xs={8}>{origin}</Col>
        </Row>
        <Row className="mb-1">
          <Col xs={4} className="pr-0">
            <strong>Destino:</strong>
          </Col>
          <Col xs={8}>{destiny}</Col>
        </Row>
        <Row className="mb-1">
          <Col xs={4} className="pr-0">
            <strong>Fecha:</strong>
          </Col>
          <Col xs={8}>
            {new Date(dateTime)
              .toLocaleString("es-AR", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                timeZone: "America/Argentina/Buenos_Aires",
                hour12: false,
              })
              .replace(",", "")}
          </Col>
        </Row>
        <Row className="mb-1">
          <Col xs={4} className="pr-0">
            <strong>Velocidad:</strong>
          </Col>
          <Col xs={8}>{speed} km/h</Col>
        </Row>
        <Row className="mb-0">
          <Col xs={4} className="pr-0">
            <strong>Precisión:</strong>
          </Col>
          <Col xs={8}>{presicion} mts</Col>
        </Row>
        <Row className="mt-3">
          {!isParentAccount ? (
            <Col
              xs={6}
              className="text-center cursor-pointer px-0"
              onClick={() => {
                details(getUrlByRole(role, tripId, detailId));
              }}
            >
              <h6 className="mb-0">
                <strong>Detalle</strong>
              </h6>
            </Col>
          ) : null}
          <Col
            xs={isParentAccount ? 12 : 6}
            className="text-center cursor-pointer px-0"
            onClick={handleRouteToggle}
          >
            <h6 className="mb-0">
              <strong>{visibleRoute ? "Ocultar ruta" : "Mostrar ruta"}</strong>
            </h6>
          </Col>
        </Row>
      </Card.Body>
      <div
        style={{
          position: "absolute",
          bottom: "-6px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: "6px solid white",
        }}
      />
    </Card>
  );
}

export default MapOverlay;
